import { render, staticRenderFns } from "./UserChatChannelSideBar.vue?vue&type=template&id=3726f926"
import script from "./UserChatChannelSideBar.vue?vue&type=script&lang=js"
export * from "./UserChatChannelSideBar.vue?vue&type=script&lang=js"
import style0 from "./UserChatChannelSideBar.vue?vue&type=style&index=0&id=3726f926&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports